var styles = {"fontElementMap":"_6FIE9","orderedlist":"mQu3Q","bulletedlist":"BZfO-","listItem":"bCoVg"};

export { styles as s };
//# sourceMappingURL=lists-920b1918.js.map
